import { SEARCH_CARS } from '../actionsTypes';
import { None, MIN_PRICE, MAX_PRICE } from '../../constants';

const setSearchCars = (cars, searchResult) => {
  const searchedCars = cars
    .filter((item) => {
      const brand = searchResult.get('Brand') || None;
      if (brand !== None) return item.Car.Brand === brand;
      return item;
    })
    .filter((item) => {
      const model = searchResult.get('Model') || None;
      if (model !== None) return item.Car.Model === model;
      return item;
    })
    .filter((item) => {
      const bodyType = searchResult.get('BodyId') || None;
      if (bodyType !== None) return item.Car.BodyId === bodyType;
      return item;
    })
    .filter((item) => {
      const minYear = searchResult.get('MinYear') || None;
      if (minYear !== None) return item.Car.Year >= minYear;
      return item;
    })
    .filter((item) => {
      const maxYear = searchResult.get('MaxYear') || None;
      if (maxYear !== None) return item.Car.Year <= maxYear;
      return item;
    })
    .filter((item) => {
      const transmissionType = searchResult.get('TransmissionId') || None;
      if (transmissionType !== None) return item.Car.TransmissionId === transmissionType;
      return item;
    })
    .filter((item) => {
      const engineType = searchResult.get('EngineId') || None;
      if (engineType !== None) return item.Car.EngineId === engineType;
      return item;
    })
    .filter((item) => {
      const minPrice = searchResult.get('MinPrice') || MIN_PRICE;
      return item.Car.Price >= minPrice;
    })
    .filter((item) => {
      const maxPrice = searchResult.get('MaxPrice') || MAX_PRICE;
      return item.Car.Price <= maxPrice;
    });
  return ({ type: SEARCH_CARS, payload: searchedCars });
};

export default setSearchCars;
